// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZZzoXDqNYbeZFA4Nz1CF{background:#fff;width:100%}.Q6Jqe2_V8hD646bgJHc5 .RAq6xZXnFK1L5TVeNs8w{display:flex;align-items:center;padding:4px;cursor:pointer;text-decoration:none;overflow:hidden;border-radius:24px}.Q6Jqe2_V8hD646bgJHc5 .RAq6xZXnFK1L5TVeNs8w label{margin-right:8px;font-weight:700;font-size:14px;line-height:18px;padding:4px;border-radius:4px;color:#8496b9}.Q6Jqe2_V8hD646bgJHc5 .RAq6xZXnFK1L5TVeNs8w h3{font-family:"Rubik",serif;color:#131a4f;font-size:14px;line-height:16px;font-weight:400;padding-right:1em;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;margin:0}.Q6Jqe2_V8hD646bgJHc5 .RAq6xZXnFK1L5TVeNs8w:hover{background:#f8f8f8}.Q6Jqe2_V8hD646bgJHc5 .RAq6xZXnFK1L5TVeNs8w.lcjFkxnzOM8wY3OFIScW label{color:#6e32f0}.Q6Jqe2_V8hD646bgJHc5 .RAq6xZXnFK1L5TVeNs8w.lcjFkxnzOM8wY3OFIScW:hover{background:#400daf}.Q6Jqe2_V8hD646bgJHc5 .RAq6xZXnFK1L5TVeNs8w.lcjFkxnzOM8wY3OFIScW:hover h3,.Q6Jqe2_V8hD646bgJHc5 .RAq6xZXnFK1L5TVeNs8w.lcjFkxnzOM8wY3OFIScW:hover label{color:#fff}.Q6Jqe2_V8hD646bgJHc5 .RAq6xZXnFK1L5TVeNs8w.Zhb2b4XW0abmsOo6RhLB,.Q6Jqe2_V8hD646bgJHc5 .RAq6xZXnFK1L5TVeNs8w:active{background:#6e32f0}.Q6Jqe2_V8hD646bgJHc5 .RAq6xZXnFK1L5TVeNs8w.Zhb2b4XW0abmsOo6RhLB h3,.Q6Jqe2_V8hD646bgJHc5 .RAq6xZXnFK1L5TVeNs8w.Zhb2b4XW0abmsOo6RhLB label,.Q6Jqe2_V8hD646bgJHc5 .RAq6xZXnFK1L5TVeNs8w:active h3,.Q6Jqe2_V8hD646bgJHc5 .RAq6xZXnFK1L5TVeNs8w:active label{color:#fff}.Q6Jqe2_V8hD646bgJHc5:last-of-type{border-bottom:1px solid #ecedf5}.NoTnhIny1313MsKHTl13{display:flex;align-items:center;padding:6px 11px}.NoTnhIny1313MsKHTl13 i{color:#8496b9;margin-right:6px}.NoTnhIny1313MsKHTl13 h3{font-family:"Rubik",serif;color:#8496b9;font-style:normal;font-size:14px;line-height:26px;font-weight:600;margin:0;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"navigation": `ZZzoXDqNYbeZFA4Nz1CF`,
	"chapter": `Q6Jqe2_V8hD646bgJHc5`,
	"chapterItem": `RAq6xZXnFK1L5TVeNs8w`,
	"completed": `lcjFkxnzOM8wY3OFIScW`,
	"active": `Zhb2b4XW0abmsOo6RhLB`,
	"chapterHeader": `NoTnhIny1313MsKHTl13`
};
export default ___CSS_LOADER_EXPORT___;
